import React from "react";

export function Input({ className = "", ...props }) {
  return (
    <input
      className={`w-full px-3 py-2 rounded-lg border border-secondary bg-background text-textPrimary focus:outline-none focus:ring-2 focus:ring-primary ${className}`}
      {...props}
    />
  );
}
